class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector('.drawer__inner');
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.closeButton = this.querySelector('.drawer__close');

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);

    // Close drawer events
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());

    // Listen for cart changes
    document.addEventListener('cart:change', () => this.render());

    // Initial load
    this.render();
  }

  async render() {
    try {
      const cart = await this.getCart();

      // Update subtotal, items, empty state via cart-items.js
      const itemsElement = this.querySelector('cart-items');
      if (itemsElement) itemsElement.render(cart);

    } catch (error) {
      console.error('CartDrawer render error:', error);
    }
  }

  async getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  open() {
    this.classList.add('active');
    this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

    // Prevent background scroll
    document.body.classList.add('overflow-hidden');

    // For ESC key closing
    document.addEventListener('keyup', this.onKeyUp);
    document.addEventListener('click', this.onBodyClick, true);

    this.focusDrawer();
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('keyup', this.onKeyUp);
    document.removeEventListener('click', this.onBodyClick, true);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  onBodyClick(event) {
    if (event.target.closest('cart-drawer')) return;
    this.close();
  }

  focusDrawer() {
    // Move focus to drawer for accessibility
    const focusTarget = this.drawer || this;
    focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus();
  }
}

customElements.define('cart-drawer', CartDrawer);
